// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkHoursForm_root_2DeDi","btn":"WorkHoursForm_btn_R8Tfk"};